import React from 'react'

import { trackEvent } from '../app/ga'

function trackMenuClick(item) {
  return function trackMenuClickHanler() {
    trackEvent('navigation', 'click', item.title)
    return !!item.href
  }
}

const Nav = ({
  titleImg, // 100x17
  logoImg, // 60x45
  items,
  logoItem,
}) => (
  <nav id="main-nav" className="nav-down">
    <div id="nav-color" className="gradient-color" />

    <div className="nav-wrapper">
      {/*<!-- Add your Logo and Name here -->*/}
      <a
        className="brand-logo design-font waves-effect waves-light no-bg left-align"
        data-scroll-nav={logoItem.dataScrollNav}
        href={logoItem.href || '#'}
      >
        <img
          className="responsive-img logo"
          src={logoImg || 'http://placehold.it/120x120'}
          alt=""
        />
        {titleImg && (
          <img className="responsive-img title" src={titleImg} alt="" />
        )}
      </a>

      {/*<!-- Main Menu Hamburger Icon for Mobile And Screen Width less than 993px -->*/}
      <a href="#" data-activates="mobile-demo" className="button-collapse">
        <div className="very_small_hamburger" id="hamburger-menu">
          <svg viewBox="0 0 800 600">
            <path
              d="M300,220 C300,220 520,220 540,220 C740,220 640,540 520,420 C440,340 300,200 300,200"
              className="top"
            />
            <path d="M300,320 L540,320" className="middle" />
            <path
              d="M300,210 C300,210 520,210 540,210 C740,210 640,530 520,410 C440,330 300,190 300,190"
              className="bottom"
              transform="translate(480, 320) scale(1, -1) translate(-480, -318) "
            />
          </svg>
        </div>
      </a>

      {/*<!-- Main Menu Content -->*/}
      <ul className="right hide-on-med-and-down">
        {items.map(item => (
          <li key={item.title}>
            <a
              className={`waves-effect waves-light${
                item.dataScrollNav === 0 ? ' no-bg' : ''
              }`}
              onClick={trackMenuClick(item)}
              data-scroll-nav={item.dataScrollNav}
              href={item.href || '#'}
            >
              {item.title}
            </a>
          </li>
        ))}
      </ul>

      {/*<!--Side Nav for Mobile And Screen Width less than 993px-->*/}
      <ul className="side-nav" id="mobile-demo">
        {/*<!--Side Nav Add Logo and Name here-->*/}
        <li>
          <a
            className="waves-effect waves-light home  no-bg"
            data-scroll-nav="0"
            href="#"
          >
            <img
              className="responsive-img logo"
              src={logoImg || 'http://placehold.it/120x120'}
              alt="Conf-One"
            />
            <br />
            <img
              className="responsive-img title"
              src={titleImg || 'http://placehold.it/100x17'}
              alt="Conf-One"
            />
          </a>
        </li>

        {items.map(item => (
          <li key={item.title}>
            <a
              className="waves-effect waves-light"
              data-scroll-nav={item.dataScrollNav}
              onClick={trackMenuClick(item)}
              href={item.href || '#'}
            >
              {item.title}
            </a>
          </li>
        ))}
      </ul>
    </div>
  </nav>
)

export default Nav



// WEBPACK FOOTER //
// ./src/components/Nav.js